import { render, staticRenderFns } from "./LayoutFullWidth.vue?vue&type=template&id=2e428d26&scoped=true&"
import script from "./LayoutFullWidth.vue?vue&type=script&lang=js&"
export * from "./LayoutFullWidth.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFullWidth.vue?vue&type=style&index=0&id=2e428d26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e428d26",
  null
  
)

export default component.exports